/**
 * 机构管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const institutionService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.INSTITUTION.LIST, { 
      params
    });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.INSTITUTION.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.INSTITUTION.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.INSTITUTION.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.INSTITUTION.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(API_ENDPOINTS.INSTITUTION.BATCH_DELETE, { data: ids });
  }
};